import { Link } from 'react-router-dom';
import { Brand, CenteredCardLayout } from '../../components/layout/CenteredCardLayout';
import { ROUTES } from '../../lib/routes';

export default function NotFoundPage() {
  return (
    <CenteredCardLayout>
      <div className="stack">
        <Brand />
        <header>
          <h1>Không tìm thấy trang</h1>
          <p className="muted">Trang bạn tìm không tồn tại hoặc đã được di chuyển.</p>
        </header>
        <div className="stack">
          <Link className="btn btn--primary btn--full" to={ROUTES.account}>
            Về trang tài khoản
          </Link>
          <Link className="btn btn--secondary btn--full" to={ROUTES.login}>
            Đến trang đăng nhập
          </Link>
        </div>
      </div>
    </CenteredCardLayout>
  );
}
